// @flow
import type { Location } from 'history'
import cookies from 'js-cookie'
import AUTH_ROUTES from 'modules/auth/routes-map'
import { Logger } from 'utils/logger'
import type { Location as AppLocation } from '../types'

export function changeToLoginRoute(location: Location, getState: () => Array<AppLocation>) {
  if (location.pathname.includes(AUTH_ROUTES.REGISTRATION) || location.pathname.includes(AUTH_ROUTES.LOGIN)) {
    const state = getState()
    const prevLocation = state[state.length - 2]

    if (!prevLocation) {
      Logger.error("Couldn't get prev location when trying set after_sign_in_path")

      return
    }

    const { url } = prevLocation

    cookies.set('after_sign_in_path', `${url.pathname}${url.search}`)
  }
}
